export enum CorporateBadgeType {
  CORPORATE = 'corporate-badge.svg',
}
